import React from "react";
import { useSettings } from "@/context/SettingsContext";

export default function About() {
  const { settings } = useSettings();
  const about = settings?.about || {};
  return (
    <div className="max-w-4xl mx-auto px-4 sm:px-6 py-14">
      <p className="text-wheat text-xs font-semibold uppercase tracking-widest mb-3">About Areeba</p>
      <h1 className="font-serif text-4xl font-bold text-forest-dark">Our Story</h1>
      <div className="rounded-3xl overflow-hidden aspect-[16/7] my-8 shadow-xl">
        <img src="https://images.unsplash.com/photo-1567337710282-00832b415979?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400" alt="Areeba" className="h-full w-full object-cover" />
      </div>
      <p className="text-charcoal/75 leading-relaxed text-lg">{about.story}</p>

      <div className="grid sm:grid-cols-2 gap-6 mt-10">
        <div className="bg-sand rounded-2xl p-6">
          <h2 className="font-serif text-2xl text-forest-dark">Our Promise</h2>
          <p className="text-charcoal/70 mt-3">{about.promise}</p>
        </div>
        <div className="bg-sand rounded-2xl p-6">
          <h2 className="font-serif text-2xl text-forest-dark">Our Process</h2>
          <p className="text-charcoal/70 mt-3">{about.process}</p>
        </div>
      </div>

      <div className="mt-10 bg-forest-950 text-cream rounded-2xl p-6 text-sm">
        <p className="text-wheat font-semibold mb-2">Proprietor</p>
        <p>Gajala Parveen — Areeba Multigrain Aata</p>
        <p className="text-cream/70 mt-1">{settings?.contact?.address}</p>
        <p className="text-cream/70">Udyam Registered · Production 30–50 kg/day initially</p>
      </div>
    </div>
  );
}
